module.exports = {
	"articleTitle1": "Ross cuts regular admissions to focus on pre-admits ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Ross School of Business",
	"bathroomrating": [
		{
			"rating": 5,
			"bathroom": "1st Floor"
		},
		{
			"rating": 5,
			"bathroom": "Blau"
		}
	],
	"articleLink2": "https://www.michigandaily.com/section/statement/rethinking-ross-unglamorous-realities-business-school-education",
	"articleSnippet1": "Sep 13, 2016 ... Starting in the fall 2017 semester, the Ross School of Business will no longer \noffer the option for prospective undergraduate students to apply ...",
	"articleSnippet2": "Aug 18, 2015 ... The sophomore was just getting settled in at orientation as a new member of the \nRoss School of Business, and was being introduced to his ...",
	"articleLink1": "https://www.michigandaily.com/section/news/ross-aims-increase-number-pre-admits",
	"articleTitle2": "Rethinking Ross: The unglamorous realities of a business school ...",
	"address": "701 Tappan Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160327/eyx.NEW_.RossIndiaBusinessConference.3.26.16.052.jpg?itok=t-g0uLkS",
			"caption": "Yashwant Sinha, former Minister of External Affairs and of Finance, talks about the issues in the Indian economy at the Ross India Business Conference in Blau Auditorium on Saturday.",
			"author": "Elizabeth Xiong"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160329/kmp.NEW_.JasmineRand.3.28.16467_0.jpg?itok=rk9X_5fX",
			"caption": "Jasmine Rand, civil rights attorney for the families of Trayvon Martin, Tamir Rice, and Michael Brown, discusses the importance of collective activism in the Ross School of Business on Monday.",
			"author": "Kristina Perkins"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170201/pfa.NEW_.ross_.2.01.17.61.jpg?itok=EmBqJLeh",
			"caption": "The Ross School of Business demonstrated solidarity with international students with the #OneRoss campaign.",
			"author": "Paul Ahnn"
		}
	],
	"position": {
		"lat": 42.2727,
		"lng": -83.7376
	},
	"tips": [
		{
			"text": "Sunday mornings are a great time to study at Ross. The lighting in the building is great, and there are not many people there.",
			"person": "Christian Neubacher"
		},
		{
			"text": "Bring a jacket and dress in layers, it can be really cold in some places.",
			"person": "Aisvaryah Chandrakanthan"
		},
		{
			"text": "The fourth floor reading room (of Blau Hall) is a great, super quiet space to study. There are also usb outlets and plugs at every single seat, so you never have to worry about sitting near an outlet.",
			"person": "Natalie Jacobson"
		},
		{
			"text": "Connected to Blau Hall is the Ross Hotel, which has two great vending machines, that take credit cards.",
			"person": "Kennedy Werner"
		}
	],
	"totalMisc": 1,
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ross.json
// module id = 963
// module chunks = 0